import { useScrollReveal } from '@/hooks/useScrollReveal';
import NavBar from './components/NavBar';
import HeroSection, { MouseGlow } from './components/HeroSection';
import ProductSection from './components/ProductSection';
import ArchitectureSection from './components/ArchitectureSection';
import { ScenarioSection, TrustBadgesSection, PartnersSection } from './components/SectionsA';
import { TestimonialsSection, CustomerCasesSection, TechBlogSection } from './components/SectionsB';
import { TeamSection, CTASection, Footer } from './components/SectionsC';
import BackToTop from '@/components/feature/BackToTop';

export default function LandingPage() {
  useScrollReveal();
  return (
    <div className="min-h-screen bg-background-950 text-foreground-100">
      <MouseGlow />
      <NavBar />
      <HeroSection />
      <ProductSection />
      <ArchitectureSection />
      <TrustBadgesSection />
      <ScenarioSection />
      <PartnersSection />
      <CustomerCasesSection />
      <TestimonialsSection />
      <TechBlogSection />
      <TeamSection />
      <CTASection />
      <Footer />
      <BackToTop />
    </div>
  );
}